<template>
  <div id="flip-item">
    <!-- admin tabs -->
    <v-tabs
      v-if="user.admin"
      right class="mb-5"
    >
      <v-tab
        v-for="(nav, nv) in adminNav"
        :key="nv"
        :to="{ name: nav.route, params: nav.params }"
        :disabled="nav.disabled"
      >
        {{ nav.title }}
      </v-tab>
    </v-tabs>

    <router-view></router-view>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'FlipItem',

    computed: {
      ...mapGetters([
        'user',
        'flipAsset'
      ]),

      adminNav: function () {
        return [
          {
            title: 'View',
            route: 'flipItem',
            disabled: false,
            params: {
              id: this.$route.params.id
            }
          },
          {
            title: 'Edit',
            route: 'flipItemEdit',
            disabled: false,
            params: {
              id: this.$route.params.id
            }
          },
          {
            title: 'Images',
            route: 'flipItemEditImages',
            disabled: false,
            params: {
              id: this.$route.params.id
            }
          },
          {
            title: 'Investors',
            route: 'flipItemInvestors',
            params: {
              id: this.$route.params.id
            }
          },
          {
            title: 'History',
            route: 'flipItemHistory',
            disabled: this.flipAsset.salesState !== 'Purchased',
            params: {
              id: this.$route.params.id
            }
          },
        ]
      }
    },

    methods: {
      ...mapActions([
        'getFlipAssetById'
      ]),
    },

    async created() {
      // Grab the asset and owner.
      await this.getFlipAssetById(this.$route.params.id)
    }
  }
</script>
